import styled from "styled-components";
import { Tab } from "react-bootstrap";
import { } from "../../../constants";

export const TabContent = styled(Tab.Pane)``;
